import { createContext, useContext } from 'react';
import type { FeatureToggles } from 'types/FeatureToggleTypes';

export const FeatureToggleContext = createContext<FeatureToggles | null>(null);

export const useFeatureTogglesContext = () => useContext(FeatureToggleContext);
